<!--
 * @Author: zhaoliang
 * @Date: 2024-10-09 15:17:13
 * @LastEditTime: 2026-03-20 19:02:29
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/Membership/component/DeleteAccount/index.vue
 *
-->
<template>
  <div class="account-deletion-container">
    <h2 class="global-title">{{ $t('mbs-select-deletion') }}</h2>
    <div v-if="currentStep === 1">
      <div class="content-wrapper">
        <p class="tips-title">{{ $t('account-deletion-step1-title') }}</p>
        <p class="tips-desc">
          {{ $t('account-deletion-step1-desc') }}
        </p>
        <p class="tips-desc tips-desc-list">
          <img :src="deletionIcon" alt="" /><span> {{ $t('account-deletion-step1-desc1') }}</span>
        </p>
        <p class="tips-desc tips-desc-list">
          <img :src="deletionIcon" alt="" /><span> {{ $t('account-deletion-step1-desc2') }}</span>
        </p>
        <p class="tips-desc tips-desc-list">
          <img :src="deletionIcon" alt="" /><span> {{ $t('account-deletion-step1-desc3') }}</span>
        </p>
      </div>
      <div class="help-wrapper">
        <p class="help-title">{{ $t('account-deletion-step1-help-title') }}</p>
        <i18n-t keypath="account-deletion-step1-help-desc" tag="p" class="help-desc">
          <span
            style="font-weight: 600; text-decoration: underline; cursor: pointer"
            @click="goToContactUs"
            >{{ $t('account-deletion-step1-help-desc-link') }}</span
          >
        </i18n-t>
      </div>
      <div class="footer-btn">
        <button @click="deleteCheck" class="delete-btn">
          {{ $t('account-deletion-step1-btn') }}
        </button>
      </div>
    </div>
    <div v-if="currentStep === 2">
      <div class="content-wrapper">
        <p class="tips-title">{{ $t('account-deletion-step2-title') }}</p>
        <p class="tips-desc">
          {{ $t('account-deletion-step2-desc') }}
        </p>
        <input
          type="text"
          id="username"
          autocomplete="off"
          style="display: block; height: 0; opacity: 0"
        />
        <div class="input-wrapper">
          <img class="icon-lock" src="~img/icon-lock-gray.svg" alt="" />
          <input
            :type="passwordInputType"
            :placeholder="$t('prebook-book-check-title')"
            autocomplete="new-password"
            v-model="password"
            :class="{ error: passwordInputErr }"
            @input="passwordInputErr = false"
          />
          <img
            v-show="showPsw"
            class="icon-eye"
            src="~img/icon-feather-eye-on.svg"
            @click="
              showPsw = !showPsw;
              passwordInputType = 'password';
            "
            alt="hide password"
          />
          <img
            v-show="!showPsw"
            class="icon-eye"
            src="~img/icon-feather-eye-off.svg"
            @click="
              showPsw = !showPsw;
              passwordInputType = 'text';
            "
            alt="show password"
          />
          <p class="err-msg" v-if="passwordInputErr">{{ passwordInputErrMsg }}</p>
        </div>
        <p class="tips-desc forgot-psw" @click="goToForgotPsw">
          {{ $t('account-deletion-step2-forgot-password') }}
        </p>
      </div>
      <div class="footer-btn">
        <button @click="goToStep1" class="cancel-btn">{{ $t('cancel') }}</button>
        <button @click="goToStep3" class="confirm-btn">{{ $t('btn-done') }}</button>
      </div>
    </div>
    <div v-if="currentStep === 3">
      <div class="content-wrapper">
        <p class="tips-title">{{ $t('account-deletion-step3-title') }}</p>
        <p class="tips-desc">
          {{ $t('account-deletion-step3-desc') }}
        </p>
      </div>
      <div class="footer-btn">
        <button @click="goToStep2" class="cancel-btn">{{ $t('cancel') }}</button>
        <button @click="deleteUser" :class="['delete-btn warning', { isLoading }]">
          {{ $t('account-deletion-step3-btn') }}
        </button>
      </div>
    </div>
    <div v-if="currentStep === 9">
      <div class="content-wrapper">
        <p class="tips-title">{{ $t('account-deletion-step9-title') }}</p>
        <i18n-t keypath="account-deletion-step9-desc" tag="p" class="tips-desc">
          <router-link
            to="/account/contact"
            style="font-weight: 600; text-decoration: underline; cursor: pointer"
            >{{ $t('account-deletion-step9-contact-us') }}</router-link
          >
        </i18n-t>
      </div>
      <div class="footer-btn">
        <button @click="goToMyTrips" class="confirm-btn">
          {{ $t('prebook-book-success-btn') }}
        </button>
      </div>
    </div>
    <div class="success-modal" v-if="showSuccess">
      <div class="success-modal-overlay"></div>
      <div class="success-modal-content">
        <p class="success-modal-text">{{ $t('account-deletion-success-title') }}</p>
        <img class="success-modal-icon" src="~img/icon-success.svg" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import store from '@/store';

  export default {
    name: 'DeleteAccount',
    data() {
      return {
        currentStep: 1,
        showPsw: false,
        passwordInputType: 'password',
        passwordInputErr: false,
        passwordInputErrMsg: '',
        password: '',
        isLoading: false,
        showSuccess: false,
      };
    },
    mounted() {},
    computed: {
      ...mapState(['userInfo']),
      deletionIcon() {
        return require(`../../../../assets/images/icon-account-deleticon.svg`);
      },
    },
    methods: {
      goToStep1() {
        this.currentStep = 1;
      },
      goToStep2() {
        this.currentStep = 2;
      },
      goToStep3() {
        if (!this.password) {
          this.passwordInputErr = true;
          this.passwordInputErrMsg = this.$t('error-field-required');
          return;
        }
        const { userId, sessionId } = this.userInfo;
        this.$http.login
          .verifyUserPassword({
            encryptPw: this.password,
            userId,
            sessionId,
            lang: this.$i18n.locale,
          })
          .then(res => {
            if (res.state === '11' && res.data) {
              this.currentStep = 3;
            } else {
              this.$messageModal.show({
                image: false,
                closeIcon: true,
                desc: res.note,
                confirmBtn: this.$t('ok'),
                justHide: true,
                i18nNeed: false,
              });
            }
          });
      },
      goToForgotPsw() {
        this.$router.push({ name: 'Login', query: { type: 'forget' } });
      },
      deleteCheck() {
        this.isLoading = true;
        const { userId, sessionId } = this.userInfo;
        this.$http.login
          .checkUserOrder({ userId, sessionId })
          .then(res => {
            if (res.state === '11') {
              if (res.data) {
                this.currentStep = 9;
              } else {
                this.currentStep = 2;
              }
            } else {
              this.$messageModal.show({
                image: false,
                closeIcon: true,
                desc: res.note,
                confirmBtn: this.$t('ok'),
                justHide: true,
                i18nNeed: false,
              });
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
      deleteUser() {
        this.isLoading = true;
        const { userId, sessionId } = this.userInfo;
        this.$http.login
          .deleteUser({ userId, sessionId })
          .then(res => {
            if (res.state === '11' && res.data) {
              this.showSuccess = true;
              setTimeout(() => {
                this.showSuccess = false;
                store.dispatch('loginModule/logout');
              }, 2000);
            } else {
              this.$messageModal.show({
                image: false,
                closeIcon: true,
                desc: res.note,
                confirmBtn: this.$t('ok'),
                justHide: true,
                i18nNeed: false,
              });
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
      },
      goToMyTrips() {
        this.$router.push({ name: 'MyTrips' });
      },
      goToContactUs() {
        this.$router.push({ path: '/account/contact' });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .account-deletion-container {
    @include global-title();
    .global-title {
      margin-bottom: 32px;
    }

    .content-wrapper {
      width: 60%;
      padding-bottom: 50px;
      border-bottom: 1px solid #8b9baa;
      .tips-title {
        @include font(24px, 600);
        line-height: 32px;
        margin-bottom: 18px;
      }
      .tips-desc {
        @include font(18px, 400);
        line-height: 24px;
        margin-bottom: 38px;
      }

      .tips-desc-list {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
          margin-right: 8px;
        }
      }

      .input-wrapper {
        position: relative;
        width: 70%;
        margin-bottom: 20px;

        .icon-lock {
          position: absolute;
          left: 14px;
          top: 14px;
          width: 30px;
          height: 30px;
        }

        input {
          width: 100%;
          height: 58px;
          padding: 12px 50px;
          border: 1px solid #b1bdc4;
          border-radius: 6px;
          box-sizing: border-box;
          line-height: 1.5;
          @include font(18px, 400);

          &.error {
            border-color: #cc2222;
          }
        }

        .icon-eye {
          position: absolute;
          right: 14px;
          top: 15px;
          width: 28px;
          height: 28px;
        }

        .err-msg {
          margin-top: 10px;
          @include font(18px, 400);
          color: #cc2222;
        }
      }

      .forgot-psw {
        font-weight: 600;
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .help-wrapper {
      margin-top: 40px;
      width: 60%;

      .help-title {
        @include font(18px, 600);
        line-height: 28px;
        margin-bottom: 8px;
      }

      .help-desc {
        @include font(18px, 400);
        line-height: 28px;
      }
    }

    .footer-btn {
      width: 60%;
      display: flex;
      margin-top: 40px;
      justify-content: space-between;

      .delete-btn {
        @include font(22px, 600);
        border-radius: 8px;
        color: #fff;
        padding: 16px 40px;
        background-color: #ba9252;

        &.isLoading {
          color: #667077;
          background-color: #eceef0;
        }

        &.warning {
          background-color: #e02d3c;
        }
      }

      .cancel-btn {
        @include font(22px, 600);
        border-radius: 8px;
        color: #163049;
        margin-right: 24px;
        padding: 16px 40px;
        border: 2px solid #163049;
        background-color: #fff;
        cursor: pointer;
      }

      .confirm-btn {
        @include font(22px, 600);
        border-radius: 8px;
        color: #fff;
        padding: 16px 40px;
        background-color: #ba9252;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .success-modal {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9999;

      .success-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(22, 48, 73, 0.96);
      }

      .success-modal-content {
        display: flex;
        position: absolute;
        top: 20%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 500px;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .success-modal-text {
          @include font(28px, 700);
          line-height: 1.5;
          color: #fff;
          text-align: center;
          margin-bottom: 40px;
        }

        .success-modal-icon {
          display: block; /* 去除默认的行内元素间隙 */
          width: 100px;
          height: 100px;
        }
      }
    }

    // @media screen and (max-width: 1024px) {
    //   .loading-spinner {
    //     width: 80px;
    //     height: 80px;
    //   }
    //   .loading-text {
    //     width: 80%;
    //     line-height: 28px;
    //   }
    // }
  }

  @media screen and (max-width: 1024px) {
    .account-deletion-container {
      flex-direction: column;

      .global-title {
        @include font(18px, 600);
        line-height: 40px;
        margin-bottom: 22px;
        padding: 0;
      }

      .content-wrapper {
        width: 100%;
        padding-bottom: 30px;

        .tips-title {
          @include font(14px, 600);
          line-height: 20px;
          margin-bottom: 12px;
        }

        .tips-desc {
          @include font(12px, 400);
          line-height: 18px;
          margin-bottom: 28px;

          img {
            width: 18px;
            height: 18px;
            margin-right: 5px;
          }
        }

        .tips-desc-list {
          margin-bottom: 10px;
        }

        .input-wrapper {
          width: 100%;

          .icon-lock {
            position: absolute;
            left: 12px;
            top: 12px;
            width: 22px;
            height: 22px;
          }

          input {
            height: 46px;
            padding: 10px 40px;
            @include font(14px, 400);
          }

          .icon-eye {
            right: 12px;
            top: 12px;
            width: 22px;
            height: 22px;
          }

          .err-msg {
            @include font(14px, 400);
          }
        }
      }

      .help-wrapper {
        margin-top: 20px;
        width: 100%;

        .help-title {
          @include font(14px, 600);
          line-height: 20px;
          margin-bottom: 8px;
        }

        .help-desc {
          @include font(12px, 400);
          line-height: 18px;
        }
      }

      .footer-btn {
        width: 100%;
        margin-top: 20px;

        .delete-btn {
          width: 100%;
          @include font(16px, 600);
          padding: 8px 16px;
        }

        .cancel-btn {
          width: 100%;
          @include font(16px, 600);
          padding: 8px 16px;
        }

        .confirm-btn {
          width: 100%;
          @include font(16px, 600);
          padding: 8px 16px;
        }
      }

      .success-modal {
        .success-modal-content {
          width: 100%;

          .success-modal-text {
            @include font(22px, 700);
            line-height: 1.5;
            margin-bottom: 20px;
          }

          .success-modal-icon {
            display: block; /* 去除默认的行内元素间隙 */
            width: 80px;
            height: 80px;
          }
        }
      }
    }
  }
</style>
